var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestCheckIncorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z",
    fill: "#E20000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3595 13.5312L15.5993 8.29143C15.7936 8.09714 16.033 8 16.3176 8C16.6021 8 16.8416 8.09714 17.0359 8.29143C17.2301 8.48571 17.3273 8.72603 17.3273 9.01237C17.3273 9.29874 17.2301 9.53906 17.0359 9.73334L11.0832 15.6914C10.8775 15.8971 10.6362 16 10.3595 16C10.0828 16 9.84161 15.8971 9.63588 15.6914L7.28876 13.3443C7.09448 13.15 6.99823 12.9097 7.00002 12.6233C7.00183 12.337 7.09987 12.0967 7.29416 11.9024C7.48844 11.7081 7.72877 11.6109 8.01513 11.6109C8.30148 11.6109 8.54179 11.7081 8.73608 11.9024L10.3595 13.5312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestCheckIncorrect);
export default __webpack_public_path__ + "static/media/testCheck_incorrect.2fc092ea73df8aa53d3fec16e8dc7a32.svg";
export { ForwardRef as ReactComponent };